import { render, staticRenderFns } from "./OaoFormRadioGroup.vue?vue&type=template&id=c0e43be4&scoped=true"
import script from "./OaoFormRadioGroup.vue?vue&type=script&lang=js"
export * from "./OaoFormRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./OaoFormRadioGroup.vue?vue&type=style&index=0&id=c0e43be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e43be4",
  null
  
)

export default component.exports